export default "__VITE_ASSET__CAz_qwr1__"